import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.css'],
    standalone: false,
})
export class ToggleSwitchComponent {
    @Input() name!: string;
    @Input() value: boolean;

    @Output() onChange = new EventEmitter();

    @ViewChild('checkBox') checkbox: ElementRef;

    checked: boolean = false;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.checked = this.value;
        }
    }

    ngAfterViewInit(): void {
        if (this.checkbox.nativeElement && this.value !== undefined) {
            this.checkbox.nativeElement.checked = this.value;
            this.checked = this.value;
        }
    }

    toggleClick(event: InputEvent) {
        this.checked = (event.currentTarget as HTMLInputElement).checked;
        this.onChange.emit((event.currentTarget as HTMLInputElement).checked);
    }
}
